import { observable, configure } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';

configure({ enforceActions: 'always' });

class ProductListStore extends LocalModel {
    constructor() {
        super('productList', {
            namePlural: 'productLists',
            namePluralReal: 'productlists',
            sort: 'name',
            limit: 1000,
            api: {
                load: { url: '/api/productlists/', params: {} },
                save: { url: '/api/productlists/', params: {} },
                delete: { url: '/api/productlists/', params: {} },
            },
        });
    }

    @observable productLists = [];

    @observable adminProductLists = [];

    loadPublished = async () => {
        const response = await util.fetchApi('/api/productlists/', { method: 'GET' }, {});
        if (response && response.status === 200) {
            this.updateKeyValue('productLists', response.data || []);
        }
        return response;
    }

    loadAdmin = async () => {
        const response = await util.fetchApi('/api/productlists/admin/', { method: 'GET' }, {});
        if (response && response.status === 200) {
            this.updateKeyValue('adminProductLists', response.data || []);
        }
        return response;
    }

    previewList = async (id) => util.fetchApi(`/api/productlists/${id}/preview`, { method: 'POST' }, {});

    createList = async ({ name, supplier, description }) => {
        const response = await util.fetchApi('/api/productlists/', { method: 'POST' }, { name, supplier, description });
        if (response && response.status === 201) { await this.loadAdmin(); }
        return response;
    }

    uploadItems = async (id, { csvText, columnMapping = {}, vatSettings = {} }) => {
        const response = await util.fetchApi(`/api/productlists/${id}/upload`, { method: 'POST' }, { csvText, columnMapping, vatSettings });
        if (response && response.status === 200) { await this.loadAdmin(); }
        return response;
    }

    updateMeta = async (id, fields) => {
        const response = await util.fetchApi(`/api/productlists/${id}`, { method: 'PATCH' }, fields);
        if (response && response.status === 200) { await this.loadAdmin(); }
        return response;
    }

    removeList = async (id) => {
        const response = await util.fetchApi(`/api/productlists/${id}`, { method: 'DELETE' }, {});
        if (response && response.status === 200) { await this.loadAdmin(); }
        return response;
    }
}

const store = new ProductListStore();
export default store;

export { ProductListStore };
